<div class="bg-slate-50 font-sans text-slate-900">
  <section
    class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden"
  >
    <div
      class="p-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/50"
    >
      <h2 class="font-semibold text-slate-800 m-0">Items</h2>
      <div class="flex items-center gap-3">
        <span
          class="text-[10px] font-bold text-slate-400 uppercase tracking-wider"
          >Drag to reorder</span
        >
        <lib-item-selector
          [es_entityName]="es_entityName()"
          [activeList]="activeList()"
          (listChanged)="changeList($event!)"
          (refreshLists)="loadLists(surveyId()!)"
          [filteredLists]="filteredLists()"
          (searchChanged)="searchTerm.set($event)"
        ></lib-item-selector>
      </div>
    </div>
    @switch (activeList()?.list_type) { @case (listType.NORMAL_LIST) {
    <lib-list-option-manager
      #listOptionManagerRef
      [activeListId]="activeListId()"
      [extraButton]="extraButton()"
      [surveyId]="surveyId()"
      [questionId]="questionId()"
      (configurationSettingEvent)="handleConfigurationSetting($event)"
    ></lib-list-option-manager>
    } @case (listType.CONSTRUCTED_LIST) {
    <lib-dynamic-list-preview
      [displayNames]="dynamicPreviewItems"
      [extraButton]="extraButton()"
      (editListEvent)="handleEditDynamicList()"
      (configurationSettingEvent)="handleConfigurationSetting($event)"
    ></lib-dynamic-list-preview>
    } }
  </section>
</div>
